<template>
  <component
    class="ndfe-component"
    v-if="component"
    :is="component"
    v-bind="computedProps"
    v-on="$listeners"
  >
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
  </component>
</template>

<script>
import loaderMixin from '@/mixins/loader';
import { convertName } from '@/helpers';
import componentsRef from '@/helpers/loaders/componentsRef';
import vuetify from '@/plugins/vuetify';
import setup from '@/helpers/setup';

import(/* webpackChunkName: "fe-core" */ '@/styles/core.scss');

export default {
  name: 'CustomElement',
  vuetify,
  mixins: [loaderMixin],
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
    context: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    direction: {
      handler(newVal, oldVal) {
        const { body } = document;
        if (oldVal) body.classList.remove(`v-component--is-${oldVal}`);
        body.classList.add(`v-component--is-${newVal}`);
        body.setAttribute('dir', newVal);

        // update the attach node direction modals/tooltips etc
        const attachNode = document.getElementById('ndfc-attach-node');
        if (attachNode && oldVal) attachNode.classList.remove(`v-component--is-${oldVal}`);
        if (attachNode) attachNode.classList.add(`v-component--is-${newVal}`);

        // update vuetify direction
        this.$vuetify.rtl = newVal === 'rtl';
      },
      immediate: true,
    },
  },
  computed: {
    direction() {
      return this.getters('app/getDirection');
    },
    computedProps() {
      // all the data is passed as one prop called data
      // this is a json string
      // core values are related to the vuetify level props
      // values are related to any custom data passed into the component
      const data = this.data ? JSON.parse(this.data) : {};

      return {
        ...this.$attrs,
        ...data,
      };
    },
    comp() {
      const names = convertName(this.name);
      return componentsRef[names.kebabName];
    },
  },
  async mounted() {
    setup.mounted({ parentElement: this.$el.parentElement });
    this.load();
  },
};
</script>
